export default "__VITE_ASSET__d9107575__"